<table>
  @for (option of parsed; track option) {
    <tr>
      <td>
        @switch (option.type) {
          @case ('color') {
            <span translate>color</span>
          }
          @case ('material') {
            <span translate>material</span>
          }
          @case ('size') {
            <span translate>size</span>
          }
          @default {
            {{ option.name }}
          }
        }
        :
      </td>
      <td>
        @switch (option.type) {
          @case ('boolean') {
            @if (option.value) {
              <span translate>true</span>
            }
            @if (!option.value) {
              <span translate>false</span>
            }
          }
          @default {
            {{option.value }}
          }
        }
      </td>
    </tr>
  }
</table>
